interface InfoItemProps {
  headerOne: string;
  headerTwo: string;
  description: string;
  values?: Array<{ titre: string; content: string }>;
}

function InfoItem({ headerOne, headerTwo, description, values }: InfoItemProps) {
  return (
    <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-all duration-300">
      <div className="p-8">
        <h3 className="text-2xl font-heading font-bold text-blue-900 mb-4">
          {headerOne} <span className="text-blue-600">{headerTwo}</span>
        </h3>
        
        <div className="w-16 h-1 bg-blue-600 mb-6"></div>
        
        <p className="text-gray-700 mb-6 leading-relaxed">
          {description}
        </p>
        
        {values && (
          <div className="space-y-6 mt-8">
            {values.map((value, index) => (
              <div key={index} className="bg-gray-50 p-5 rounded-lg border-l-4 border-blue-500">
                <h4 className="text-lg font-heading font-bold text-blue-900 mb-2">
                  {value.titre}
                </h4>
                <p className="text-gray-700">
                  {value.content}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default InfoItem;